import {type LastUpdatedFilterValue} from './types';

export const LAST_UPDATED_FILTER_DEFAULT_VALUE: LastUpdatedFilterValue = 'show_all';

export const LAST_UPDATED_FILTER_OPTIONS = [
  {id: 'last_30_days', labelKey: 'last_updated_last_30_days'},
  {id: 'last_90_days', labelKey: 'last_updated_last_90_days'},
  {id: 'older_than_90_days', labelKey: 'last_updated_older_than_90_days'},
  {id: 'show_all', labelKey: 'last_updated_show_all'},
] as const;

const LAST_UPDATED_FILTER_OPTION_ID_SET = new Set<LastUpdatedFilterValue>(
  LAST_UPDATED_FILTER_OPTIONS.map((option) => option.id)
);

const hasLastUpdatedFilterOptionId = (value: string): value is LastUpdatedFilterValue =>
  LAST_UPDATED_FILTER_OPTION_ID_SET.has(value as LastUpdatedFilterValue);

export const resolveLastUpdatedFilterValue = (
  values: unknown[] | undefined,
  defaultValue: LastUpdatedFilterValue = LAST_UPDATED_FILTER_DEFAULT_VALUE
): LastUpdatedFilterValue => {
  for (const value of values ?? []) {
    if (typeof value !== 'string') continue;
    if (hasLastUpdatedFilterOptionId(value)) {
      return value;
    }
  }
  return defaultValue;
};
